import { Component } from '@angular/core';

@Component({
  selector: 'app-zip-file',
  standalone: true,
  imports: [],
  templateUrl: './zip-file.component.html',
  styleUrl: './zip-file.component.css',
})
export class ZipFileComponent {}
